import { Obj } from "scrivito"
import { ProjectPageObjAttributes } from "scrivito/Objs/ProjectPage/ProjectPageObjClass"
import { SharedProjectPageObjAttributes } from "scrivito/Objs/SharedProjectPage/SharedProjectPageObjClass"

interface UseProjectChatButtonModelArgs {
  page: Obj<ProjectPageObjAttributes | SharedProjectPageObjAttributes>
}

export function useProjectChatButton({ page }: UseProjectChatButtonModelArgs) {
  // const { show } = useContext(ProjectChatContext)

  // 7267 -- Comment this back in in case the project chat should be re-enabled

  // const project = useDataItem("Project")
  // const sharedProject = useDataItem("SharedProject")

  // const projectID = project?.get("projectId") || sharedProject?.get("projectId")

  // const scope = Opportunity.all().transform({
  //   search: `external_id=${projectID}`
  // })
  // const opportunity = useMemo(() => scope?.take()[0], [scope, projectID])

  // const isHidden = useMemo(() => {
  //   if (!page.get("enableChat")) {
  //     return true
  //   }
  //   if (!opportunity && page.get("hideChatWhenNoOpportunity")) {
  //     return true
  //   }
  //   return false
  // }, [page, opportunity])

  return {
    label: page.get("chatButtonText"),
    isHidden: true,
    onClick: undefined
  }
}
